import { toast } from './toast';

interface CopyableValueProps {
  label: string;
  value: string;
}

/**
 * Renders a labeled value as a card. Tapping the value copies it to the clipboard.
 */
export function CopyableValue({ label, value }: CopyableValueProps) {
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      toast(`Kopiert: ${value}`);
    } catch {
      toast('Konnte nicht kopieren', 'error');
    }
  };

  return (
    <div class="card">
      <div class="label">{label}</div>
      <div class="value" onClick={onCopy}>{value}</div>
      <div class="hint">Antippen zum Kopieren</div>
    </div>
  );
}
